import { TestLocators } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';
import { ReactNode } from 'react';

export interface LabeledElementProps {
  label: string;
  children: ReactNode;
  testId?: TestLocators | string;
}

export function LabeledElement({ label, testId, children }: LabeledElementProps) {
  return (
    <div data-testid={testId}>
      <MUI.InputLabel>{label}</MUI.InputLabel>
      <MUI.Box sx={{ marginTop: '4px' }}>{children}</MUI.Box>
    </div>
  );
}
